<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import BulkImportSummaryHero from '../shared/BulkImportSummaryHero.vue'

const { t } = useI18n()
</script>

<template>
  <div
    class="flex flex-col items-center justify-center text-center gap-2 flex-1 p-6"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <BulkImportSummaryHero />

    <h2 class="text-2xl font-semibold text-grey-950 leading-8">
      {{ t('corp.bulk_import.validating.title') }}
    </h2>

    <p class="text-sm text-grey-600 max-w-sm leading-normal tracking-tooltip">
      {{ t('corp.bulk_import.validating.desc') }}
    </p>
  </div>
</template>
